import i18n from '@dms/i18n';

export const getPaymentMethodOptions = () => [
  {value: 'CASH', label: i18n.t('entity.invoice.paymentMethod.cash')},
  {value: 'PAYMENT_CARD', label: i18n.t('entity.invoice.paymentMethod.card')},
  {value: 'BANK_TRANSFER', label: i18n.t('entity.invoice.paymentMethod.bankTransfer')},
  {value: 'OFFSET', label: i18n.t('entity.invoice.paymentMethod.offset')},
  {value: 'CASH_ON_DELIVERY', label: i18n.t('entity.invoice.paymentMethod.cashOnDelivery')},
];
